import { testimonials } from '../../../mocks/artworks';

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-[#E8E8E8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-vip-diamond-line text-[#e8a65b] text-xl"></i>
            <span className="text-xs uppercase tracking-widest text-gray-600 font-medium">
              Testimonios
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C4A52] mb-6">
            Lo Que Dicen Los <span className="text-[#e8a65b]">Coleccionistas</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#e8a65b] text-lg"></i>
                ))}
              </div>
              
              <div className="mb-6">
                <i className="ri-double-quotes-l text-5xl text-[#e8a65b]/20"></i>
              </div>

              <p className="text-gray-700 text-sm leading-relaxed mb-6">
                {testimonial.text}
              </p>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top rounded-full"
                  />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm">{testimonial.name}</h4>
                  <p className="text-xs text-gray-500">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}